import React from 'react';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import ReusableLayout from '../components/ReusableLayout';

const config = [
  { title: 'Регистрация в приложении', amount: 100 },
  { title: 'Приглашение друга (за каждого)', amount: 350 },
  { title: 'Взаимная симпатия', amount: 25 },
  { title: '4 фотографии в профиле', amount: 100 },
  { title: 'Добавление аудио визитки', amount: 50 },
  { title: 'Первое сообщение после взаимной симпатии', amount: 20 },
  { title: 'Покупка подарков (за каждый)', amount: 20 },
  { title: 'Просмотр трансляций в течении 15 минут (ежедневное вознаграждение)', amount: 60 },
  { title: 'Покупка MYTA Premium', amount: '20 000' },
];

function Menu() {
  const navigate = useNavigate();

  const headerProps = {
    showBackButton: true,
    onBackClick: () => navigate(-1),
    centerContent: (
      <img
        src="/logo1.svg"
        className="w-[134px] h-auto absolute left-1/2 top-[35px] transform -translate-x-1/2 -translate-y-1/2"
        alt="Logo"
      />
    ),
    className: 'border-b border-[#233636] h-[81px] relative',
    variant: 'transparent',
  };

  return (
    <ReusableLayout
      variant="page"
      showHeader={true}
      headerProps={headerProps}
      className="min-h-[100%] text-white"
      style={{
        background: 'linear-gradient(180deg, rgb(1, 13, 13) 4%, rgb(19, 47, 50) 100%)',
      }}
    >
      <div className="flex flex-col items-center w-full px-4 py-4">
        <p className="font-raleway font-bold text-[24px] text-[#a1f69e] mb-4 text-center">О нашем приложении</p>

        <p className="text-white">
          Наше приложение помогает не просто найти пару, но и провести идеальный вечер в реальном мире.
        </p>

        <p className="text-white">
          За каждую активность в приложении ты получаешь очки
          <img className="w-[18px] h-[18px] inline ml-1" src="/icons/myta-coin.svg" alt="myta-coin" />
        </p>

        <p className="text-white mb-3">
          <span className="font-bold">Скоро</span> накопленные очки можно будет обменивать на скидки и оплачивать до
          100% счета в лучших заведениях-партнёрах: кафе, ресторанах, кино и барах!
        </p>
        <img className="w-full max-h-[262px] mb-6" src="/images/myta-idia.png" alt="myta" />
        <p className="font-bold text-lg text-white mb-3">За что начисляются очки активности:</p>
        <div className="space-y-1.5 mb-6">
          {config.map((item, index, array) => (
            <div
              key={index}
              className={`flex items-start justify-between gap-1 pb-1.5 text-white ${array.length - 1 !== index ? 'border-b border-white/30' : ''}`}
            >
              <p>{item.title}</p>
              <p className="font-bold flex items-center gap-1 truncate min-w-0 shrink-0">
                +{item.amount}
                <img className="size-[18px] shrink-0" src="/icons/myta-coin.svg" alt="myta-coin" />
              </p>
            </div>
          ))}
        </div>
        <p className="font-bold text-lg text-white">Благодарим за выбор MYTA ❤️</p>

        <Button className="mt-[37px] mb-6" onClick={() => navigate('/calculatePage')}>
          Далее
        </Button>
      </div>
    </ReusableLayout>
  );
}

export default Menu;
